import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";

export class CreaturePanelWithCheck extends Container {

    private creaturePanel!: CreaturePanel;
    private checked!: boolean;
    private check!: Phaser.GameObjects.Image;
    private border!: Phaser.GameObjects.Image;
    private checkCallback!: (checked: boolean) => unknown;

    constructor(scene: Scene, x: number, y: number, c: Creature, price: number, selectSound: BaseSound | undefined,
                onDeadCallback: () => unknown, checkCallback: (checked: boolean) => unknown, isPlayerCreature?: boolean, checked?: boolean, smallClickArea?: boolean) {
        super(scene);
        let self = this;
        this.x = x;
        this.y = y;
        this.checked = checked ? checked :false;
        this.checkCallback = checkCallback;

        this.creaturePanel = new CreaturePanel(scene, 0, 0, c, onDeadCallback, isPlayerCreature, true);
        let box = SpriteUtils.addImage(this.scene, 0, 125, Keys.ATLAS_PROFILE, Keys.UI_BOX);
        let check = SpriteUtils.addImage(this.scene, 0, 125, Keys.ATLAS_PROFILE, Keys.UI_CHECK).setVisible(this.checked);
        let border = SpriteUtils.addImage(this.scene, 0, 36, Keys.ATLAS_PROFILE, Keys.UI_BORDER, 1.3, 1.42).setAlpha(self.checked ? 1 : 0.2);
        this.check = check;
        this.border = border;

        if(!smallClickArea){
            border.setInteractive().on('pointerup', () => {
                SoundUtils.play(selectSound);
                self.checked = !self.checked;
                check.setVisible(self.checked);
                border.setAlpha(self.checked ? 1 : 0.2);
                checkCallback(self.checked);
            });
        } else {
            box.setInteractive().on('pointerup', () => {
                SoundUtils.play(selectSound);
                self.checked = !self.checked;
                check.setVisible(self.checked);
                border.setAlpha(self.checked ? 1 : 0.2);
                checkCallback(self.checked);
            });
        }

        const formatter = new Intl.NumberFormat("de-DE", {
            style: 'decimal',
            useGrouping: true,
        });

        let priceText = TextUtils.addText(this.scene, price ? formatter.format(price) : '0', -5, 98,
            '#ffffff', 12, 'normal', 100);

        let gemIcon = SpriteUtils.addImage(this.scene, priceText.getRightCenter().x! + 10, 99, Keys.IMG_RES_MITHRIL);
        SpriteUtils.setDispSize(gemIcon, 24, 24);

        this.add([border, this.creaturePanel, box, priceText, gemIcon, check]);
    }

    public setHealthVisible() {
        this.creaturePanel.setHealthVisible();
    }

    public getCreature(): Creature {
        return this.creaturePanel.getCreature();
    }

    public setChecked(checked: boolean){
        this.checked = checked;
        this.check.setVisible(this.checked);
        this.border.setAlpha(this.checked ? 1 : 0.2);
        this.checkCallback(this.checked);
    }

    public isChecked(){
        return this.checked;
    }

}